/**
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

import '@neo4j-ndl/base/lib/neo4j-ds-styles.css';

import { Tabs, Typography } from '@neo4j-ndl/react';
import {
  CircleStackIconOutline,
  DatabasePlusIcon,
  InboxArrowDownIconOutline,
} from '@neo4j-ndl/react/icons';
import { useState } from 'react';

type TabValues = 'database' | 'add' | 'inbox';

const Component = () => {
  const [value, setValue] = useState<TabValues>('database');

  return (
    <div className="n-mt-5">
      <Tabs value={value} onChange={setValue} className="n-mb-token-8">
        <Tabs.Tab id="database" description="Database">
          <CircleStackIconOutline />
        </Tabs.Tab>
        <Tabs.Tab id="add" description="Add database">
          <DatabasePlusIcon />
        </Tabs.Tab>
        <Tabs.Tab id="inbox" description="Inbox">
          <InboxArrowDownIconOutline />
        </Tabs.Tab>
      </Tabs>
      <Tabs.TabPanel value={value} tabId="database">
        <Typography variant="body-medium">
          Database management and operations.
        </Typography>
      </Tabs.TabPanel>
      <Tabs.TabPanel value={value} tabId="add">
        <Typography variant="body-medium">
          Add new database or connection.
        </Typography>
      </Tabs.TabPanel>
      <Tabs.TabPanel value={value} tabId="inbox">
        <Typography variant="body-medium">
          Inbox notifications and messages.
        </Typography>
      </Tabs.TabPanel>
    </div>
  );
};

export default Component;
